import { useTranslation } from "@impero-com/common/utils/i18n";
import { useOutletContext } from "react-router-dom";

import { AssignmentTable } from "org/user/components/AssignmentTable";
import { useTestingActivitiesForUserQuery } from "org/user/queries/useTestingActivitiesForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import {
    TestingActivityRow,
    useUserTestingActivityListTable,
} from "./useUserTestingActivityListTable";

export function UserTestingActivitiesList() {
    const { user } = useOutletContext<OutletContext>();
    const userId = user.id;

    const { data: testingActivities } =
        useTestingActivitiesForUserQuery(userId);
    const { t } = useTranslation();

    const { table, getFilterComponent, canAddException, tableId } =
        useUserTestingActivityListTable(testingActivities, userId);

    const modeConfig = getFilterModeConfig(t);

    return (
        <AssignmentTable<TestingActivityRow>
            table={table}
            tableId={tableId}
            getFilterComponent={getFilterComponent}
            canAddException={canAddException}
            modeConfig={modeConfig}
        />
    );
}
